<template>
  <div class="q_mar_b70px q_pad_lr15px">

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_mar_t15px q_mar_b20px q_pad_b20px q_after_bor_b q_po_re" v-for="item in list" :key="item.id"
             @click="goToArtdea(item)">
          <van-swipe-cell>
            <div class="q_vertical_left q_po_re" style="width: 100%;">

              <van-button v-if="item.noticeType == '2'" type="primary" size="mini" color="#FFC300">系统消息</van-button>
              <span v-if="item.noticeType == '2'" class="q_text_m q_bold q_mar_l10px q_inlineblock">系统消息</span>
              <van-button v-if="item.noticeType == '1'" type="primary" size="mini" color="#FF8D1A">通知公告</van-button>
              <span v-if="item.noticeType == '1'" class="q_text_m q_bold q_mar_l10px q_inlineblock">通知公告</span>
              <van-button v-if="item.noticeType == '3'" type="primary" size="mini" color="#FF5733">活动消息</van-button>
              <span v-if="item.noticeType == '3'" class="q_text_m q_bold q_mar_l10px q_inlineblock">活动消息</span>
              <van-badge v-if="item.isRead!='1'" dot>
              </van-badge>
              <span class="q_text_s q_color_gray q_po_ab" style="right: 0;">{{ item.createTime }}</span>
            </div>
            <div class="q_text_m q_bold q_moit1 q_mar_t15px">{{ item.noticeTitle }}</div>
            <div class="q_text_s q_color_gray q_moit2 q_mar_t5px q_justify">
              <div v-text="html2Escape(item.noticeContent)"></div>
            </div>
            <span class="q_text_s q_color_gray q_mar_t20px q_block">查看详情</span>
            <template #right>
              <van-button square text="删除" type="danger" @click="delnot(item.noticeId)" class="delete-button"/>
            </template>
          </van-swipe-cell>
        </div>


      </van-list>

    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
  </div>
</template>

<script>
import {delNoticeById, listNotice, upNoticeById} from "@/api/notice";
import Vue from 'vue';
import {Badge, SwipeCell} from 'vant';
import {wxCloseShare} from "@/utils/jiutang";

Vue.use(Badge);

Vue.use(SwipeCell);


export default {
  name: 'News',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 5,
      },
    }
  },
  created() {
    wxCloseShare()
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 5,
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //获取公告信息
      listNotice(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToArtdea(row) {
      if (row.isRead == null || row.isRead == undefined) {
        //已读
        var params = {
          noticeId: row.noticeId,
          isRead: '1'
        }
        upNoticeById(params).then(res => {
          if (res.code == '200') {
            this.$router.push({
              path: '/news/noticedea', query: {id: row.noticeId}
            });
          }
        })
      } else {
        this.$router.push({
          path: '/news/noticedea', query: {id: row.noticeId}
        });
      }


    },
    delnot(id) {
      console.log('删除', id)
      delNoticeById(id).then(res => {
        console.log('sss', res)
        if (res.code == '200') {
          this.list = []
          this.onRefresh()
          this.$modal.success("删除成功");
        }
      })
    },
    html2Escape(str) {
      if (str == null){
        return ''
      }
      str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
      str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
      //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
      str = str.replace(/ /ig, '');//去掉
      var arrEntities = {'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"'};
      return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
        return arrEntities[t];
      });
    }
  }
}
</script>
<style scoped="scoped">
.q_after_bor_b >>> .van-button--mini {
  height: 18px;
}

.delete-button {
  height: 100%;
}

.van-badge--dot {
  margin-top: -3vw;
}

>>> .van-swipe-cell__right {
  right: -1px;
}
</style>
